import React from "react";
import { Stack } from "@mui/material";
import BotonEtiquetaPedidoN2 from "./BotonEtiquetaPedidoN2";
import { ORDER_STATE_N2 } from "../../../../config/constants";

/**
 * Botón de etiqueta de un pedido de Nave 2 en los listados. La etiqueta de altura /
 * Tronja 3 ya no tiene botón propio: sale con la normal si el pedido tiene esos
 * productos. Con la precarga aún en curso (`undefined`) o fallida (`null`), el botón
 * carga los productos al pulsar. Un pedido ya preparado no muestra el botón, como el
 * "Imprimir" del punteo, que desaparece con el pedido completo.
 */
const EtiquetasPedidoN2 = ({ pedido, productos }) => {
    if (String(pedido?.state) === ORDER_STATE_N2.PREPARADO) return null;

    return (
        <Stack direction="row" spacing={0.5} onClick={(e) => e.stopPropagation()}>
            <BotonEtiquetaPedidoN2 pedido={pedido} productos={productos || undefined} />
        </Stack>
    );
};

export default EtiquetasPedidoN2;
